import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type PlacementCandidate } from "@src/appV2/redesign/PlacementCandidate/types";
import { type InterviewWithDetails } from "@src/appV2/redesign/WorkerShifts/api/useFetchPaginatedInterviews";

import { type WorkerOutcomeResult } from "../../api/useUpdateInterview";
import { ReferralShareContent } from "../ReferralShareContent";
import { type FeedbackStep } from "./feedbackStep";
import { useInterviewAttendanceSource } from "./useInterviewAttendanceSource";

interface ReferralPromptContentProps {
  step?: FeedbackStep;
  placementCandidate: PlacementCandidate;
  interview?: InterviewWithDetails;
  gotOfferOption?: WorkerOutcomeResult;
}

export function ReferralPromptContent(props: ReferralPromptContentProps) {
  const { step, placementCandidate, interview, gotOfferOption } = props;

  const source = useInterviewAttendanceSource();

  return (
    <ReferralShareContent
      title="Congrats on the offer!"
      description="Know someone looking for a permanent job?"
      shareText={(referralLink, amount) =>
        `Hey! I just got a job through Clipboard Health. Use my link to apply and we'll both get $${amount} once you complete an interview.\n\n${referralLink}`
      }
      viewedEvent={APP_V2_APP_EVENTS.PLACEMENT_INTERVIEW_ATTENDANCE_REFERRAL_VIEWED}
      shareClickedEvent={APP_V2_APP_EVENTS.PLACEMENT_INTERVIEW_ATTENDANCE_REFERRAL_SHARE_CLICKED}
      analyticsContext={{
        step,
        placementCandidate,
        interview,
        source,
        gotOfferOption,
      }}
    />
  );
}
